import SubPageShell from "@/components/SubPageShell";
import TosBlock from "@/components/TosBlock";

export default function TosPage() {
  return (
    <SubPageShell testId="tos-page">
      {(config) => <TosBlock tos={config.settings?.tos || []} />}
    </SubPageShell>
  );
}
